import React from 'react'

const Notfound = () => {
  return (
    <div className="container">Notfound</div>
  )
}

export default Notfound